import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import { saveCaseFailure, saveCaseSuccess, OFLC_SAVE_CASE } from '../actions';

import util from '../../../global/utils/Helpers';
import 'isomorphic-fetch';
import { polyfill } from 'es6-promise';
polyfill();

let apiIndex = util.isLocalhost() ? 'http://localhost:9393/auth/visa/' : `${util.getCurrentHost()}/auth/auth/visa/`;

const fetchUpdateCase = (action$) =>
	action$.pipe(
		ofType(OFLC_SAVE_CASE),
		mergeMap((action) =>
			fetch(apiIndex + action.payload.form_id, {
				credentials: 'include',
				method: 'PATCH',
				body: JSON.stringify(action.payload),
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Basic ' + window.btoa('flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1')
				}
			})
				.then((response) => response.json())
				.then((data) => {
					if (
						data.statusCode === 500 ||
						data.statusCode === 502 ||
						data.statusCode === 503 ||
						data.statusCode === 429
					) {
						return saveCaseFailure();
					} else {
						return saveCaseSuccess(data);
					}
				})
				.catch((error) => saveCaseFailure())
		)
	);

export default fetchUpdateCase;
